import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Products: ParentMenuProps = {
  label: 'Products',
  description: 'Run your business with online ordering, payroll, and more',
  heapClass: 'ca_topnav_pdps',
  gridCols: 'grid-cols-4 xl:grid-cols-8 min-[1440px]:pl-[156px]',
  showcaseMobile: true,
  subMenus: [
    {
      label: 'Front of House',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Point of Sale',
          icon: 'before:content-icon-hardware-flex',
          url: '/products/point-of-sale',
          heapClass: 'ie_nav_pos'
        },
        {
          label: 'Handheld POS',
          icon: 'before:content-icon-toast-go',
          url: '/products/handheld-pos',
          heapClass: 'ie_nav_hhpos'
        },
        {
          label: 'Self-Ordering Kiosk',
          icon: 'before:content-icon-kiosk',
          url: '/hardware/restaurant-kiosk',
          heapClass: 'ie_nav_kiosk'
        },
        {
          label: 'Toast Mobile Order & Pay®',
          icon: 'before:content-icon-software-mobile-order-pay',
          url: '/products/mobile-order-and-pay',
          heapClass: 'ie_nav_mobileorder'
        }
      ]
    },
    {
      label: 'Back of House',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Kitchen Display System',
          icon: 'before:content-icon-flex-for-kitchen-2',
          url: '/hardware/kitchen-display-system',
          heapClass: 'ie_nav_kds'
        }
      ]
    },
    {
      label: 'Digital Guest Engagement',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Email Marketing',
          icon: 'before:content-icon-software-email-marketing',
          url: '/products/toast-marketing',
          heapClass: 'ie_nav_email'
        },
        {
          label: 'Loyalty',
          icon: 'before:content-icon-solutions-loyalty',
          url: '/products/loyalty',
          heapClass: 'ie_nav_loyalty'
        },
        {
          label: 'Online Ordering',
          icon: 'before:content-icon-software-online-ordering',
          url: '/products/online-ordering',
          heapClass: 'ie_nav_oo'
        },
        {
          label: 'Reservations & Waitlist',
          icon: 'before:content-icon-solutions-tables',
          url: '/products/reservations-and-waitlist',
          heapClass: 'ie_nav_tables'
        },
        {
          label: 'Gift Cards',
          icon: 'before:content-icon-gift-card',
          url: '/products/gift-card',
          heapClass: 'ie_nav_giftcards'
        }
      ]
    },
    {
      label: 'Back Office & Team Management',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Scheduling',
          icon: 'before:content-icon-scheduling',
          url: '/products/restaurant-employee-scheduling-software',
          heapClass: 'ie_nav_rota'
        },
        {
          label: 'Reporting',
          icon: 'before:content-icon-reporting-analytics',
          url: '/products/reporting',
          heapClass: 'ie_nav_reporting'
        },
        {
          label: 'Multilocation Management',
          icon: 'before:content-icon-multi-location-management',
          url: '/products/multi-location-management',
          heapClass: 'ie_nav_mlm'
        },
        {
          label: 'Payment Processing',
          icon: 'before:content-icon-payment-processing',
          url: '/products/payments',
          heapClass: 'ie_nav_paymentproc'
        }
      ]
    }
  ]
}

export default Products
